import { SurchargeAmounts, SurchargeMargin } from './types';

const UNTYPED_COST_SHARE_OF_SELL = 0.8;

const BLANK: SurchargeMargin = { sellLocal: null, costAud: null, costLocalImplied: null, marginFraction: null };

function costAudFor(amounts: SurchargeAmounts, fxRateAudToNative: number): number {
  const typedCost = amounts.costLocal;
  return typedCost == null || !Number.isFinite(typedCost)
    ? UNTYPED_COST_SHARE_OF_SELL * amounts.sellAud
    : typedCost / fxRateAudToNative;
}

/**
 * Sell and cost across a single AUD -> local rate, plus margin. The rounding is deliberately
 * asymmetric: sell is rounded down to whole local units while cost keeps full precision, because
 * margin must be computed on the unrounded cost.
 */
export function computeSurchargeMargin(amounts: SurchargeAmounts, fxRateAudToNative: number): SurchargeMargin {
  if (!Number.isFinite(fxRateAudToNative) || fxRateAudToNative <= 0) {
    return BLANK;
  }
  if (!Number.isFinite(amounts.sellAud) || amounts.sellAud <= 0) {
    return BLANK;
  }

  const costAud = costAudFor(amounts, fxRateAudToNative);

  return {
    sellLocal: Math.floor(amounts.sellAud * fxRateAudToNative),
    costAud,
    costLocalImplied: Math.floor(costAud * fxRateAudToNative),
    marginFraction: 1 - costAud / amounts.sellAud,
  };
}
